module.exports = __webpack_public_path__ + "static/media/roll-dice-10.b3e37cdd.png";